import React from 'react';
import autoBind from 'react-autobind';

//Context
import { withGridContext } from './grid.factory';

import { Row, Col } from 'react-bootstrap';

class GridButtonFooter extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  redirect(name) {
    const { routerManager } = this.props;
    const { parameters } = name;
    if (parameters) routerManager.redirect(name);
    else routerManager.redirect({ name });
  }

  render() {
    const { context } = this.props;
    const { options, isView, data } = context;

    return (
      <Col mg={12} className="btn-forms">
        {options.onSubmit && (
          <button type="submit" className="btn btn-primary float-right" onClick={() => options.onSubmit(data)}>
            <i className={'fas fa-check'} /> Confirmar
          </button>
        )}
        {(options.onCancel || options.backRoute) && (
          <button
            type="button"
            className="btn btn-cancel float-right"
            onClick={() => (options.onCancel ? options.onCancel() : this.redirect(options.backRoute))}
          >
            <i className={`fa ${isView ? 'fa-angle-double-left' : 'fa-ban'}`} /> {`${isView ? 'Voltar' : 'Cancelar'}`}
          </button>
        )}
      </Col>
    );
  }
}

export default withGridContext(GridButtonFooter);
